import { schema } from 'normalizr'

export const availableCategoryEntity = new schema.Entity('availableCategories', {}, { idAttribute: 'categoryId' })
export const arrayOfAvailableCategories = [availableCategoryEntity]



// WEBPACK FOOTER //
// ./adapters/schemas/availableCategoriesSchema.js